import { Card as CardRoot } from './Card';
import { CardBody } from './components/CardBody';
import { CardContent } from './components/CardContent';
import { CardDescription } from './components/CardDescription';
import { CardFooter } from './components/CardFooter';
import { CardHeader } from './components/CardHeader';
import { CardImageCap } from './components/CardImageCap';
import { CardTitle } from './components/CardTitle';

export const Card = Object.assign(CardRoot, {
  Body: CardBody,
  Content: CardContent,
  Description: CardDescription,
  Footer: CardFooter,
  Header: CardHeader,
  ImageCap: CardImageCap,
  Title: CardTitle,
});
